// extracted by mini-css-extract-plugin
export default {"popularity":"popularity_popularity__2MhkU","dot":"popularity_dot__UH71r","bigDot":"popularity_bigDot__YHmPp"};